/**
 * LuxStay is PT-PT only. This stub preserves the old `useTranslation()` API
 * so existing call sites keep working, but always resolves to Portuguese.
 */
const STRINGS = {
  common: {
    login: "Entrar",
    register: "Criar conta",
    dashboard: "Área pessoal",
    gallery: "Galeria",
    logout: "Sair",
    back: "Voltar",
    language: "Idioma",
  },
  nav: {
    home: "Início",
    solution: "Solução",
    offer: "Oferta",
    story: "História",
    testimonials: "Testemunhos",
    contact: "Contacto",
  },
  home: {
    hero_eyebrow: "Gestão profissional de limpezas · Madeira",
    hero_cta: "Agendar Limpeza",
    hero_secondary: "Ver oferta",
    final_cta_heading: "Comece hoje a operar o seu alojamento de forma profissional.",
    final_cta_button: "Agendar Limpeza",
  },
  contact: {
    eyebrow: "Fale connosco",
    title_line1: "Peça um orçamento para",
    title_line2: "o seu alojamento local.",
    subtitle: "Respondemos em poucas horas com disponibilidade e preço. Se for urgente, indique o seu check-in e check-out na mensagem.",
    name: "Nome",
    email: "Email",
    phone: "Telefone",
    phone_placeholder: "Ex: 912 345 678",
    message: "Mensagem",
    message_placeholder: "Tipologia, morada, frequência desejada, check-in/check-out…",
    submit: "Enviar pedido",
    submitting: "A enviar…",
    hint: "Ao enviar, receberá uma confirmação automática no seu email.",
    success_title: "Pedido recebido.",
    success_body: "Enviámos um email de confirmação. Entraremos em contacto muito em breve.",
    success_send_another: "Enviar outro pedido",
    success_toast: "Pedido enviado. Recebemos a sua mensagem.",
  },
  gallery: {
    eyebrow: "Galeria",
    title: "O nosso padrão",
    subtitle: "Cada limpeza entregue com o nível que os seus hóspedes merecem.",
    share: "Partilhar",
    copy_link: "Copiar link",
    whatsapp: "WhatsApp",
  },
  scope: {
    title: "Incluído em cada limpeza",
    bedrooms: "Quartos",
    bathroom: "Casa de banho",
    living: "Sala",
    kitchen: "Cozinha",
    vacuum: "Aspirar",
    dust: "Limpar o pó",
  },
  auth: {
    email: "Email",
    password: "Palavra-passe",
    login_submit: "Entrar",
    register_submit: "Criar conta",
    no_account: "Ainda não tem conta?",
    have_account: "Já tem conta?",
  },
};

export function LanguageProvider({ children }) {
  return children;
}

export function useTranslation() {
  const t = (path) => {
    const parts = (path || "").split(".");
    let node = STRINGS;
    for (const p of parts) {
      if (!node || typeof node !== "object") return path;
      node = node[p];
    }
    return typeof node === "string" ? node : path;
  };
  return { lang: "pt", setLang: () => {}, t, supported: ["pt"] };
}
